import React from "react";
import { useLocation, useNavigate } from "react-router";
import { useSidebarStore } from "@/stores/SidebarStore";
import { useEffect, useState } from "react";
import { getMenus, type MenuItem } from "@/components/navigation/routes-menus";

export const SidebarLite = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isOpen, closeSidebar } = useSidebarStore();
  const [menus, setMenus] = useState<MenuItem[]>([]);
  const [expanded, setExpanded] = useState<Record<string, boolean>>({});

  useEffect(() => {
    setMenus(getMenus());
  }, []);

  const activePath = location.pathname;
  const isActive = (href?: string | null) => !!href && href === activePath;

  const toggle = (id: string) => setExpanded((p) => ({ ...p, [id]: !p[id] }));

  const onClickItem = (m: MenuItem) => {
    if (m.children?.length) {
      toggle(m.id);
      return;
    }
    if (!m.href) return;
    if (m.href.startsWith("http://") || m.href.startsWith("https://")) {
      window.location.href = m.href;
      return;
    }
    navigate(m.href);
    closeSidebar();
  };

  const render = (m: MenuItem, level = 0): React.JSX.Element => (
    <div key={`${m.id}-${level}`}>
      <button
        onClick={() => onClickItem(m)}
        disabled={!m.href && !m.children?.length}
        className={`w-full text-left px-2 py-2 rounded text-sm text-slate-600 ${
          isActive(m.href) ? "bg-blue-100 text-blue-800" : "hover:bg-slate-100"
        } ${level > 0 ? "pl-5" : "pl-3"}`}
        title={m.label}
      >
        {m.label}
      </button>
      {m.children && m.children.length > 0 && expanded[m.id] && (
        <div className="ml-3 border-l border-slate-300 pl-2">
          {m.children.map((c) => render(c, level + 1))}
        </div>
      )}
    </div>
  );

  return (
    <aside
      className={`fixed top-12 bottom-0 left-0 z-50 bg-slate-50 border-r border-slate-300 w-64 transform transition-transform ${
        isOpen ? "translate-x-0" : "-translate-x-full"
      }`}
      role="navigation"
      aria-label="Menú lateral"
    >
      <div className="p-2 overflow-y-auto h-full">
        {menus.map((m) => render(m))}
      </div>
    </aside>
  );
};
